export function isPhoneLoginEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_PHONE_LOGIN === 'true'
}

export function isStripePaymentsEnabled(): boolean {
  return import.meta.env.VITE_STRIPE_PAYMENTS_ENABLED !== 'false'
}

export function isParcelTilesEnabled(): boolean {
  return import.meta.env.VITE_PARCEL_TILES_ENABLED === 'true'
}

export function isBookingsOnboardingGateEnabled(): boolean {
  return import.meta.env.VITE_BOOKINGS_ONBOARDING_GATE_ENABLED !== 'false'
}

export function isCustomerActivationLandingEnabled(): boolean {
  return import.meta.env.VITE_CUSTOMER_ACTIVATION_LANDING_ENABLED === 'true'
}

export function isPublicEventsEnabled(): boolean {
  return import.meta.env.VITE_PUBLIC_EVENTS_ENABLED !== 'false'
}

// The upland-birds member tab is hidden while bird orders move to being charged
// against the member's cash tab. The backend still records bird balances, so this
// is a UI gate and nothing else — flip it on to see the tab again.
export function isUplandBirdsTabEnabled(): boolean {
  return import.meta.env.VITE_UPLAND_BIRDS_TAB_ENABLED === 'true'
}

export function isGalleryVideoEnabled(): boolean {
  return import.meta.env.VITE_GALLERY_VIDEO_ENABLED === 'true'
}

// Season Recap is dark-launched: the nav entry and the route are both hidden
// until this is switched on, so it can be exercised internally before any club
// manager or outfitter owner sees it.
export function isSeasonRecapEnabled(): boolean {
  return import.meta.env.VITE_SEASON_RECAP_ENABLED === 'true'
}

export function isProCrewsEnabled(): boolean {
  return import.meta.env.VITE_PRO_CREWS_ENABLED === 'true'
}
